const setRegion = ({ commit }, region) => {
  commit('SET_REGION', region);
};

export default {
  setRegion
};
